export enum QueryKey {
  TransportWarehouseInfo = "TransportWarehouseInfo",
  VehiclesRelated = "VehiclesRelated",
  VehiclesDetails = "VehiclesDetails",
}
